import posthog from 'posthog-js';

export function initPosthog() {
  if (typeof document === 'undefined') return;
  if (window.posthog && window.posthog.__loaded) return;

  const apiKey = document.querySelector('meta[name="posthog-project-api-key"]')?.content;
  if (!apiKey) return;

  const host =
    document.querySelector('meta[name="posthog-host"]')?.content ||
    'https://us.i.posthog.com';
  const environment = document.querySelector('meta[name="posthog-environment"]')?.content;

  posthog.init(apiKey, {
    api_host: host,
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    disable_session_recording: true,
    persistence: 'localStorage+cookie',
  });

  if (environment) posthog.register({ environment });

  window.posthog = posthog;
}

export default initPosthog;
